/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheCart.vue?vue&type=template&id=4d60722c&"
import script from "./TheCart.vue?vue&type=script&lang=js&"
export * from "./TheCart.vue?vue&type=script&lang=js&"
import style0 from "./TheCart.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports